import { ATTENDEE_SECTIONS, APPLICATION_SECTIONS } from '@framework/constants/enums';

const useIsMeetingDetailsView = (currentSection?: string) => {
    const isEditModeDetailsView = currentSection === APPLICATION_SECTIONS.MEETING_DETAILS;
    const isViewModeDetailsView = currentSection === ATTENDEE_SECTIONS.MEETING_DETAILS;
    const isMeetingDetailsView = isEditModeDetailsView || isViewModeDetailsView;

    return {
        isEditModeDetailsView,
        isMeetingDetailsView,
        isViewModeDetailsView
    };
};

export default useIsMeetingDetailsView;
